import React from 'react'
import { tokens, FontIcon } from '@arvoreeducacao/bonsai-ds'
import { HelpSection } from './HelpSection.styles'

const Help = () => {
  return (
    <HelpSection>
      <FontIcon
        iconName="stopsign-alert"
        color={tokens.colors.black5}
        size={16}
      />
      Não encontramos o estudante. Entre em contato pelo chat aqui no canto da
      página.
    </HelpSection>
  )
}

export default Help
